import { useEffect, useState } from "react";
import useIndexSetTemplateDefaults from "components/indices/IndexSetTemplates/hooks/useIndexSetTemplateDefaults";
import useSelectedIndexSetTemplate from "components/indices/IndexSetTemplates/hooks/useSelectedTemplate";
const useIndexSet = (initialIndexSet) => {
  const { loadingIndexSetTemplateDefaults, indexSetTemplateDefaults } = useIndexSetTemplateDefaults();
  const [indexSet, setIndexSet] = useState(initialIndexSet);
  const { selectedIndexSetTemplate } = useSelectedIndexSetTemplate();
  useEffect(() => {
    if (loadingIndexSetTemplateDefaults || !indexSetTemplateDefaults) return;
    const defaultIndexSet = {
      title: "",
      description: "",
      index_prefix: "",
      writable: true,
      shards: indexSetTemplateDefaults.shards,
      data_tiering: indexSetTemplateDefaults.data_tiering,
      replicas: indexSetTemplateDefaults.replicas,
      rotation_strategy_class: indexSetTemplateDefaults.rotation_strategy_class,
      rotation_strategy: indexSetTemplateDefaults.rotation_strategy,
      retention_strategy_class: indexSetTemplateDefaults.retention_strategy_class,
      retention_strategy: indexSetTemplateDefaults.retention_strategy,
      index_analyzer: indexSetTemplateDefaults.index_analyzer,
      index_optimization_max_num_segments: indexSetTemplateDefaults.index_optimization_max_num_segments,
      index_optimization_disabled: indexSetTemplateDefaults.index_optimization_disabled,
      field_type_refresh_interval: indexSetTemplateDefaults.field_type_refresh_interval,
      field_restrictions: indexSetTemplateDefaults.field_restrictions,
      index_set_template_id: null
    };
    if (initialIndexSet) {
      const initialIndexWithoutNullValues = Object.fromEntries(
        Object.entries(initialIndexSet).filter(([_, v]) => v != null)
      );
      setIndexSet({ ...defaultIndexSet, ...initialIndexWithoutNullValues });
    } else if (selectedIndexSetTemplate) {
      const indexSetTemplateConfig = selectedIndexSetTemplate.index_set_config;
      if (indexSetTemplateConfig.use_legacy_rotation) {
        indexSetTemplateConfig.data_tiering = indexSetTemplateDefaults.data_tiering;
      } else {
        indexSetTemplateConfig.rotation_strategy_class = indexSetTemplateDefaults.rotation_strategy_class;
        indexSetTemplateConfig.rotation_strategy = indexSetTemplateDefaults.rotation_strategy;
        indexSetTemplateConfig.retention_strategy_class = indexSetTemplateDefaults.retention_strategy_class;
        indexSetTemplateConfig.retention_strategy = indexSetTemplateDefaults.retention_strategy;
      }
      const indexSetTemplateConfigWithoutNullValues = Object.fromEntries(
        Object.entries(indexSetTemplateConfig).filter(([_, v]) => v != null)
      );
      setIndexSet({
        ...defaultIndexSet,
        ...indexSetTemplateConfigWithoutNullValues,
        index_set_template_id: selectedIndexSetTemplate.id
      });
    } else {
      setIndexSet({ ...defaultIndexSet });
    }
  }, [loadingIndexSetTemplateDefaults, indexSetTemplateDefaults, initialIndexSet, selectedIndexSetTemplate]);
  return [indexSet, setIndexSet];
};
export default useIndexSet;
